/* Independent slideshow with Shopify editor lifecycle support. No navigation hooks. */
(function () {
  'use strict';
  if (window.serlexStudioEditor) { window.serlexStudioEditor.init(document); return; }
  var instances = new Map();
  var selectedBlocks = new Map();
  function mount(root) {
    if (instances.has(root)) return;
    var slides = Array.from(root.querySelectorAll('[data-serlex-slide]'));
    if (!slides.length) return;
    var dots = Array.from(root.querySelectorAll('[data-serlex-goto]'));
    var controls = root.querySelector('[data-serlex-controls]');
    var pause = root.querySelector('[data-serlex-pause]');
    var status = root.querySelector('[data-serlex-status]');
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var editor = !!(window.Shopify && window.Shopify.designMode);
    var sectionId = root.dataset.sectionId;
    var index = 0, timer = 0, sequence = 0, manualPause = false, hovering = false, focused = false, visible = true, destroyed = false;
    var enabled = root.dataset.autoplay === 'true';
    var interval = Math.max(5000, Number(root.dataset.interval) || 7000);
    var cleanups = [], observer;
    root.dataset.initialized = 'true';
    if (controls) controls.hidden = false;
    function listen(target, name, handler) {
      if (!target) return;
      target.addEventListener(name, handler);
      cleanups.push(function () { target.removeEventListener(name, handler); });
    }
    function loadImage(slide) {
      var img = slide.querySelector('img[data-src]');
      if (!img) return Promise.resolve();
      return new Promise(function (resolve) {
        function done() { img.removeEventListener('load', done); img.removeEventListener('error', done); resolve(); }
        img.addEventListener('load', done); img.addEventListener('error', done);
        slide.querySelectorAll('source[data-srcset]').forEach(function (source) { source.srcset = source.dataset.srcset; source.removeAttribute('data-srcset'); });
        img.loading = 'eager';
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        img.removeAttribute('data-src'); img.removeAttribute('data-srcset');
        if (img.complete) done();
        cleanups.push(done);
      });
    }
    function canPlay() { return enabled && slides.length > 1 && !manualPause && !motion.matches && !editor; }
    function schedule() {
      clearTimeout(timer);
      if (destroyed) return;
      if (pause) {
        pause.textContent = editor ? 'Editing' : (motion.matches ? 'Motion off' : (canPlay() ? 'Pause' : 'Play'));
        pause.setAttribute('aria-label', editor ? 'Automatic rotation is paused while editing' : (motion.matches ? 'Automatic rotation disabled by your reduced-motion preference' : (canPlay() ? 'Pause slideshow' : 'Play slideshow')));
        pause.disabled = editor || motion.matches;
      }
      if (canPlay() && !hovering && !focused && visible && !document.hidden) timer = setTimeout(function () { show(index + 1, false); }, interval);
    }
    function show(next, userInitiated) {
      if (destroyed) return;
      var target = (next + slides.length) % slides.length;
      var change = ++sequence;
      clearTimeout(timer);
      if (userInitiated) manualPause = true;
      function reveal() {
        if (destroyed || change !== sequence || !root.isConnected) return;
        if (!userInitiated && (!canPlay() || hovering || focused || !visible || document.hidden)) { schedule(); return; }
        index = target;
        root.classList.add('serlex-hero--transition');
        slides.forEach(function (slide, i) { slide.hidden = i !== index; });
        dots.forEach(function (dot, i) { if (i === index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
        if (userInitiated && status) status.textContent = 'Slide ' + (index + 1) + ' of ' + slides.length;
        schedule();
      }
      var loading = loadImage(slides[target]);
      if (userInitiated) reveal(); else loading.then(reveal);
    }
    listen(root.querySelector('[data-serlex-prev]'), 'click', function () { show(index - 1, true); });
    listen(root.querySelector('[data-serlex-next]'), 'click', function () { show(index + 1, true); });
    dots.forEach(function (dot) { listen(dot, 'click', function () { show(Number(dot.dataset.serlexGoto), true); }); });
    listen(pause, 'click', function () { if (canPlay()) manualPause = true; else { enabled = true; manualPause = false; } schedule(); });
    listen(root, 'mouseenter', function () { hovering = true; schedule(); });
    listen(root, 'mouseleave', function () { hovering = false; schedule(); });
    listen(root, 'focusin', function () { focused = true; schedule(); });
    listen(root, 'focusout', function (event) { focused = root.contains(event.relatedTarget); schedule(); });
    listen(document, 'visibilitychange', schedule);
    if (motion.addEventListener) listen(motion, 'change', schedule);
    else { motion.addListener(schedule); cleanups.push(function () { motion.removeListener(schedule); }); }
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) { if (entries.length) { visible = entries[0].isIntersecting; schedule(); } });
      observer.observe(root);
    }
    var controller = {
      select: function (blockId, target) {
        var selected = slides.findIndex(function (slide) { return (blockId && slide.dataset.blockId === String(blockId)) || slide === target || (target && slide.contains(target)); });
        if (selected !== -1) { selectedBlocks.set(sectionId, slides[selected].dataset.blockId); show(selected, true); }
      },
      destroy: function () {
        destroyed = true; sequence++; clearTimeout(timer);
        if (observer) observer.disconnect();
        cleanups.forEach(function (cleanup) { cleanup(); });
        root.removeAttribute('data-initialized'); instances.delete(root);
      }
    };
    instances.set(root, controller);
    if (editor && selectedBlocks.has(sectionId)) controller.select(selectedBlocks.get(sectionId));
    schedule();
  }
  function roots(scope) {
    var found = Array.from(scope.querySelectorAll('[data-serlex-hero]'));
    if (scope.matches && scope.matches('[data-serlex-hero]')) found.unshift(scope);
    return found;
  }
  function init(scope) { roots(scope).forEach(mount); }
  window.serlexStudioEditor = { init: init };
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { roots(event.target).forEach(function (root) { var controller = instances.get(root); if (controller) controller.destroy(); }); });
  document.addEventListener('shopify:block:select', function (event) {
    var hero = event.target.closest && event.target.closest('[data-serlex-hero]');
    if (hero) { mount(hero); instances.get(hero).select(event.detail && event.detail.blockId, event.target); }
    else if (event.detail && event.detail.sectionId) instances.forEach(function (controller, root) { if (root.dataset.sectionId === String(event.detail.sectionId)) controller.select(event.detail.blockId, event.target); });
  });
}());
